<template>
  <v-text-field
    solo
    ref="input"
    v-currency="{
      locale: 'de',
      distractionFree: false,
      valueAsInteger: true,
      currency: { prefix: 'Rp', suffix: '' },
      allowNegative: false,
      precision: 0
    }"
    :value="formattedValue"
    @change="onChange"
    @input="onInput"
    :rules="rules"
    :outlined="outlined"
    :filled="!outlined"
    :single-line="singleLine"
    color="green"
    :label="label"
    :placeholder="placeholder"
    :disabled="isDisabled"
  />
</template>

<script>
export default {
  name: 'CurrencyInput',
  props: {
    outlined: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: null
    },
    options: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formattedValue: null
    }
  },
  watch: {
    value (value) {
      this.setValue(value)
    }
  },
  mounted () {
    this.setValue(this.value)
  },
  methods: {
    setValue (value) {
      this.$ci.setValue(this.$refs.input, value)
    },
    onInput (value) {
      this.$emit('input', this.$ci.getValue(this.$refs.input))
      this.formattedValue = value
    },
    onChange (value) {
      this.$emit('change', this.$ci.getValue(this.$refs.input))
      this.formattedValue = value
    }
  }
}
</script>
